export const macroStateOptionList = (hasExitMember: boolean) => {
  return [
    {
      value: "1",
      label: "[초대 성공] 1. 자동 초대 성공",
    },
    {
      value: "2",
      label: "[초대 실패] 2. 추가 구매 불가(패키지/타사 결제)",
    },
    {
      value: "3",
      label: "[초대 실패] 3. 추가 구매 실패",
    },
    {
      value: "4",
      label: "[초대 실패] 4. 초대 가능 슬롯 없음",
    },
    {
      value: "5",
      label: "[초대 실패] 5. 초대 가능 횟수 초과",
    },
    {
      value: "6",
      label: "[초대 실패] 6. 파티원이 별도 결제/이용중",
    },
    {
      value: "7",
      label: "[초대 실패] 7. 직접 초대 요청",
    },
    {
      value: "8",
      label: "[수락 성공] 8. 초대 수락 성공",
    },
    {
      value: "9",
      label: "[수락 실패] 9. 직접 수락 요청",
    },
    {
      value: "10",
      label: "[해지 성공] 10. 탈퇴원 해지 성공",
      isDisabled: hasExitMember ? false : true,
    },
    {
      value: "11",
      label: "[해지 실패] 11. 탈퇴원 직접 해지 요청",
      isDisabled: hasExitMember ? false : true,
    },
    {
      value: "14",
      label: "[해지 성공] 14. 종료 파티원(연장 파티원 제외) 해지 성공",
    },
    {
      value: "15",
      label: "[해지 실패] 15. 종료 파티원(연장 파티원 제외) 직접 해지 요청",
    },
    {
      value: "16",
      label: "[초대 실패] 16. 로그인 정보 무효",
    },
    {
      value: "17",
      label: "[초대 실패] 17. 이용권 무효",
    },
    {
      value: "18",
      label: "[초대 실패] 18. 파티장 본인 인증 필요(직접 초대 요청)",
    },
  ];
};

export const macroUserEventTrigger = (macroId: number) => {
  switch (macroId) {
    case 12:
    case 13:
    case 14:
    case 15:
      return "exit_ldr";

    case 16:
    case 17:
      return "ldr";

    case 10:
    case 11:
      return "exit_mbr";

    default:
      return "mbr";
  }
};

export const macroUserEventReceiver = (macroId: number) => {
  switch (macroId) {
    case 6:
      return "ldr,mbr";

    case 8:
    case 9:
      return "mbr";

    default:
      return "ldr";
  }
};
